import { render, staticRenderFns } from "./SpotExchange.vue?vue&type=template&id=085a5269&scoped=true"
import script from "./SpotExchange.vue?vue&type=script&lang=js"
export * from "./SpotExchange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085a5269",
  null
  
)

export default component.exports